import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-719fe02c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-container" }
const _hoisted_2 = { class: "animate send-friendship" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Eliminar amigo dev", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Ya no podréis mensajearos dentro de la plataforma."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Esta acción es permanente. ¿Estás seguro?")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))

import logo from '@/assets/svg/ademass.svg'
import { ref } from 'vue'
import { Toast } from '@/interfaces/ToastInterface'
import { useToast } from '@/store/useToast'
import FriendshipService from '@/services/FriendshipService'
import { useAuth } from '@/store/useAuth'


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteFriend',
  props: ['id'],
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const emit = __emit
const toast = useToast()
const friendshipService = new FriendshipService()
const store = useAuth()
const props = __props
const deleteFriend = async () => {
    if(!store.token) {
        return
    }
    const response = await friendshipService.deleteFriend(store.token, props.id)
    toast.showToast(response, Toast.INFO)
    setTimeout(function () { toast.hideToast() }, 4000);
    emit('close')
}

const close = () => {
    emit('close')
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "close",
        onClick: close
      }, [
        _createVNode(_component_v_icon, {
          name: "ri-close-circle-fill",
          fill: "lightcoral",
          scale: "1.5"
        })
      ]),
      _createElementVNode("img", {
        src: _unref(logo),
        width: "256"
      }, null, 8, _hoisted_3),
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      _createElementVNode("div", { class: "input-box" }, [
        _createElementVNode("button", {
          onClick: deleteFriend,
          class: "delete"
        }, "Estoy seguro, eliminar de mis amigos"),
        _createElementVNode("button", { onClick: close }, "Cancelar")
      ])
    ])
  ]))
}
}

})